// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import etask from '/util/etask.js';

export const read_clipboard = ()=>etask(function*(){
    try {
        const text = yield navigator.clipboard.readText();
        return text;
    } catch(e){}
    return '';
});

export const write_clipboard = value=>etask(function*(){
    try {
        yield navigator.clipboard.writeText(value);
    } catch(e){}
});

export const supports = ()=>!!navigator?.clipboard?.writeText;
